import { SearchButton, SearchClear, SearchInput, Search as SearchPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const SearchRoot = React.forwardRef(({ className, ...props }, ref) => {
    return React.createElement(SearchPrimitive, { className: cn(className), ref: ref, ...props });
});
const Search = Object.assign(SearchRoot, {
    Clear: SearchClear,
    Button: SearchButton,
    Input: SearchInput,
});
Search.displayName = "Search";
Search.Clear.displayName = "Search.Clear";
Search.Button.displayName = "Search.Button";
Search.Input.displayName = "Search.Input";
export { Search, SearchButton, SearchClear, SearchInput };
//# sourceMappingURL=search.js.map